import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';

import Tooltip from '../Tooltip';

const tooltipHideDelay = 150;
const tooltipShowDelay = 300;

const tooltipContent = () => (
  <span>
    This firm received an A+Award.&nbsp;
    <a
      tabIndex="0"
      role="button"
      href="https://enter.architizer.com/?utm_source=architizer&utm_medium=firmdirectory"
      target="_blank"
      rel="noreferrer"
    >
      Learn More
    </a>.
  </span>
);

export default class APlusBadge extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <>
        <Tooltip
          placement="bottom"
          delayHide={tooltipHideDelay}
          delayShow={tooltipShowDelay}
          tooltip={tooltipContent()}
          small
        >
          <svg className="mb-0 " width="30" height="30" viewBox="0 0 36 43" version="1.1">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <g fill="#A2B7C3">
                <path fill="#3EB3E7" d="M18,3.2L5.2,10.6v14.8L18,32.8l12.8-7.4V10.6L18,3.2z M24.3,19.5c-0.1,0.1-0.1,0.1-0.2,0.1h-4.6l0,4.6 c0,0.1,0,0.1-0.1,0.2c-0.1,0.1-0.1,0.1-0.2,0.1l-2.6,0c-0.1,0-0.1,0-0.2-0.1c-0.1-0.1-0.1-0.1-0.1-0.2l0-4.6l-4.6,0 c-0.1,0-0.1,0-0.2-0.1c-0.1-0.1-0.1-0.1-0.1-0.2l0-2.6c0-0.1,0-0.1,0.1-0.2c0.1-0.1,0.1-0.1,0.2-0.1h4.6l0-4.6c0-0.1,0-0.1,0.1-0.2 c0.1-0.1,0.1-0.1,0.2-0.1l2.6,0c0.1,0,0.1,0,0.2,0.1c0.1,0.1,0.1,0.1,0.1,0.2l0,4.6l4.6,0c0.1,0,0.1,0,0.2,0.1 c0.1,0.1,0.1,0.1,0.1,0.2l0,2.6C24.4,19.4,24.4,19.4,24.3,19.5z" />
              </g>
            </g>
          </svg>
        </Tooltip>
      </>
    );
  }
}

APlusBadge.propTypes = {
};

APlusBadge.defaultProps = {
};

Object.values(document
  .querySelectorAll('.premium-badge'))
  .filter(e => typeof e === 'object')
  .forEach((container) => {
    ReactDOM.render(<APlusBadge />, container);
  });
